<template>
  <div
    :class="[
      isCorrect && isLocked
        ? 'bg-green-700 text-white shadow-green-hard-sm'
        : isPresent && isLocked
          ? 'bg-kekkle-yellow-dark text-kekkle-dark shadow-yellow-hard-sm'
          : isWrong && isLocked
            ? 'bg-kekkle-dark-light text-white'
            : isEmpty
              ? 'shadow-hard bg-gray-300'
              : 'animate-scale border-2 border-black-dark bg-white text-black shadow-teal-hard-sm',
      isAnimating ? 'animate-scale' : '',
    ]"
    class="flex aspect-square h-full w-full max-w-[3rem] items-center justify-center rounded border-2 border-black-dark text-3xl font-medium capitalize transition-all"
  >
    {{ letter.character }}
  </div>
</template>
<script setup lang="ts">
import { computed, ref, watch } from "vue";
import type { CharacterState } from "@kekkle/shared/types/fields/wordle-game-state/wordle-game-state";

type Props = {
  letter: CharacterState;
  index: number;
};

const props = defineProps<Props>();

const isAnimating = ref(false);
const isCorrect = computed(() => props.letter.isCorrect);
const isPresent = computed(() => props.letter.isPresent);
const isEmpty = computed(() => props.letter.character === "");
const isLocked = computed(() => props.letter.isLocked);
const isWrong = computed(
  () =>
    !props.letter.isCorrect && !props.letter.isPresent && props.letter.isLocked,
);

watch(
  () => props.letter,
  (newVal, oldVal) => {
    if (
      newVal.character === oldVal.character &&
      newVal.isCorrect === oldVal.isCorrect &&
      newVal.isPresent === oldVal.isPresent &&
      newVal.isLocked === oldVal.isLocked
    ) {
      return;
    }
    isAnimating.value = true;
    setTimeout(() => {
      isAnimating.value = false;
    }, 500);
  },
);
</script>
<style>
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.animate-scale {
  animation: scale 0.5s ease-in-out;
}
</style>
